import clsx from 'clsx';
import { FC } from 'react';

export interface AttributeHeaderProps {
  title: string;
  directionMessage?: string;
  attributeClassName?: string;
}

const AttributeHeader: FC<AttributeHeaderProps> = ({
  title,
  directionMessage,
  attributeClassName,
}) => {
  return (
    <div
      className={clsx('px-6', attributeClassName, {
        'mb-2 space-y-0.5': !!directionMessage?.length,
        'mb-4': !directionMessage?.length,
      })}
    >
      <h2 className="font-bold text-content-base-default">{title}</h2>
      <p className="text-sm text-content-base-subdued">{directionMessage}</p>
    </div>
  );
};

export default AttributeHeader;
